module.exports = __webpack_public_path__ + "static/automatic-ai_4-0419f7de4ed249dfb58956db87674ae6.jpg";